import {
  DEFAULT_LIFETIME_ORDER_COOKING_TIME,
  DEFAULT_ORDER_TIME,
  DEFAULT_SIZE_PIZZA,
  LANGUAGES
} from '../constants';
import * as _ from 'lodash';
import moment from 'moment/moment';
import pathToRegexp from 'path-to-regexp';

export function calcCostPizza(product, crustID, size, quantity = 1,
                              allIngredients = [], ingredientsMinus = [], ingredientsPlus = []) {
  const option = product.options.filter(obj => {
    return obj.crust.id === parseInt(crustID, 10);
  })[0];

  if (!option) {
    return 0;
  }
  let price = parseFloat(option[size]);
  ingredientsMinus.forEach(obj => {
    let ingredient = allIngredients.filter(pi => {
      return pi.id === obj.ingredient.id;
    })[0];
    if (ingredient) {
      price -= parseFloat(ingredient[size]) * parseInt(obj.amount, 10);
    }
  });
  ingredientsPlus.forEach(obj => {
    let ingredient = allIngredients.filter(pi => {
      return pi.id === obj.ingredient.id;
    })[0];
    if (ingredient) {
      price += parseFloat(ingredient[size]) * parseInt(obj.amount, 10);
    }
  });
  return price * quantity;
}

export function calcCostProduct(product, optionQuantity, quantity = 1) {
  const index = product.options.findIndex((e) => {
    return e.quantity && e.quantity.id === optionQuantity;
  });
  let price = product.options[0]['price'];
  if (index !== -1) {
    price = product.options.length ? product.options[index]['price'] : 0;
  }
  return price * quantity;
}

export function calcCostDeal(deal, quantity = 1) {
  const price = parseFloat(deal.price);

  return price * quantity;
}

export function getCrustOfPizza(product, currentSize, language) {
  const size = currentSize || DEFAULT_SIZE_PIZZA;
  let result = [];
  if (!product.options) {
    return result;
  }
  const options = _.sortBy(product.options, ['crust.position']);
  options.forEach((obj) => {
    if (obj[size]) {
      result.push({
        value: obj.crust.id,
        label: obj.crust[`name_${language}`],
      });
    }
  });
  return result;
}

export function getFirstCrustWithSize(product, availableCrusts, availableSizes) {
  const options = _.sortBy(product.options, ['crust.id']);
  return options.find(option => {
    let result = !!option.crust;
    if (result && !!availableCrusts) {
      result = _.includes(availableCrusts, option.crust.id);
    }
    if (result) {
      result = (option['small'] || option['medium'] || option['large'])
    }
    if (result && availableSizes) {
      result = _.intersectionWith(availableSizes, Object.keys(option), (value) => {
        return !!option[value];
      }).length > 0;
    }
    return result;
  });
}

export function getSizeOfPizza(product, currentCrustID, availableSizes, availableCrusts, t=undefined) {
  const sizeVariants = ['small', 'medium', 'large'];
  let result = [];
  if (!currentCrustID && product.options.length === 0) {
    return result;
  }
  const crustId = currentCrustID || getFirstCrustWithSize(product, availableCrusts, availableSizes).crust.id;
  const crustOption = product.options.find(option => !!option.crust && option.crust.id === crustId);
  sizeVariants.forEach(variant => {
    if (!!crustOption && !!crustOption[variant]) {
      result.push({
        value: variant,
        label: t ? t(variant) : variant,
      });
    }
  });
  if (!!availableSizes) {
    return result.filter(size => _.includes(availableSizes, size.value));
  }
  return result;
}

export function getSauceOfPizza(sauces, language) {
  let result = [];
  sauces.toArray().forEach(obj => {
    result.push({
      label: obj[`name_${language}`],
      value: obj.id,
    });
  });
  return result;
}

export function getFormatPrice(price) {
  return price.toFixed(2).replace('.', ',');
}

export function actionWrapper(self, data, callback) {
  setInProgress(self, true);
  return callback(data).then((response) => {
    setInProgress(self);
    return Promise.resolve(response);
  }).catch(data => {
    if (data && data.response) {
      self.setState({
        errors: data.response.data,
      });
    }
    setInProgress(self);

    return Promise.reject(false);
  });
}

function setInProgress(self, inProgress = false) {
  self.setState({
    inProgress: inProgress,
  });
}

export function updateState(state, newState = {}) {
  return state.merge(newState);
}

export function getProductOption(basketObject, language) {
  const product = basketObject.product;
  const result = [];
  if (product.options.length > 0) {
    let option = _.find(product.options, option => {
      return option.quantity && option.quantity.id === basketObject.optionQuantity;
    });
    if (!option) {
      option = _.first(product.options);
    }
    if (!!option.quantity) {
      result.push(option.quantity[`name_${language}`]);
    }
  }
  if (product.sauces.length > 0) {
    let sauce = _.find(product.sauces, sauce => {
      return sauce.sauce && sauce.sauce.id === basketObject.sauceID;
    });
    if (!sauce) {
      sauce = _.first(product.sauces);
    }
    if (!!sauce.sauce) {
      result.push(sauce.sauce[`name_${language}`]);
    }
  }
  return result;
}

export function getCartDealDetails(restaurant, basketObject, language) {
  let result = [];
  _.map(basketObject.options, option => {
    let info, data = {};
    if (option.type === 'DealCompositionProducts') {
      info = _.find(restaurant.products, {id: option.data.productId});
      data.type = 'product';
    } else if (option.type === 'DealCompositionPizzas') {
      info = _.find(restaurant.pizzas, {id: option.data.productId});
      data.type = 'pizza';
    }
    if (!!info) {
      result.push({name: info[`name_${language}`], ...data});
    }
  });

  const count = _.countBy(result, (data) => {
    return data.type + '_' + data.name;
  });
  result = _.map(result, data => {
    data.count = count[data.type + '_' + data.name];
    return data;
  });
  return _.uniqWith(result, (arrVal, othVal) => {
    return arrVal.name === othVal.name && arrVal.type === othVal.type
  });
}

export function checkBasketIsEmpty(data) {
  let empty = true;
  if (_.isArray(data) && !_.isEmpty(data)) {
    empty = false;
  } else if (_.isObject(data) && !_.isEmpty(data.list)) {
    empty = false;
  }
  return empty;
}

export const clickOutsideConfig = {
  handleClickOutside: function (instance) {
    return instance.handleClickOutside;
  },
};

export function getPizzaExtraIngredients(obj, ingredients, language) {
  const result = [];
  _.forEach(obj.extraIngredientsMinus, extra => {
    const ingredient = _.find(ingredients, {id: extra.ingredient.id}) || {};
    result.push({
      sign: '-',
      amount: extra.amount,
      name: ingredient[`name_${language}`] || extra[`name_${language}`]
    })
  });
  _.forEach(obj.extraIngredientsPlus, extra => {
    const ingredient = _.find(ingredients, {id: extra.ingredient.id}) || {};
    result.push({
      sign: '+',
      amount: extra.amount,
      name: ingredient[`name_${language}`] || extra[`name_${language}`]
    })
  });
  return result
}

export function getOrderPeriod(restaurant) {
  let result = restaurant.default_order_cooking_time || DEFAULT_ORDER_TIME;
  if (restaurant.order_period && restaurant.order_period_modified &&
      moment(restaurant.order_period_modified)
          .add(DEFAULT_LIFETIME_ORDER_COOKING_TIME || 2, 'hours')
          .isAfter(moment())) {
    result = restaurant.order_period;
  }

  return result;
}

export function getRestaurantByName(pathname, listRestaurants) {
  return listRestaurants.find(obj => {
    return _.indexOf(pathname, obj.name_for_url) !== -1;
  });
}

export function getUriWithLanguages(pathname, lng, listRestaurants) {
  let re = pathToRegexp('/:lng?/(.*)', []);
  let pathnameSplit = re.exec(pathname);
  let pathNew = pathnameSplit[2];
  let lngFromUrl = pathnameSplit[1];
  if (!_.isUndefined(getRestaurantByName(lngFromUrl, listRestaurants))) {
    pathNew = pathnameSplit.input.substring(1);
  } else if (!_.includes(Object.keys(LANGUAGES), lngFromUrl)) {
    pathNew = pathnameSplit[2];
  }
  let toPath = pathToRegexp.compile('/:lng?/:path');
  let newPath = toPath({
    lng: lng,
    path: pathNew
  });
  return decodeURIComponent(newPath);
}

export function getLanguagesFromUri(pathname, lng) {
  let re = pathToRegexp('/:lng?', []);
  let pathnameSplit = re.exec(pathname);
  return !_.isNull(pathnameSplit) ? pathnameSplit[1] : lng;
}


// WEBPACK FOOTER //
// ./src/helpers/index.js